module.exports = __webpack_public_path__ + "static/img/publicity1.ca857f1a.png";